import React from "react";
import { Box, Typography } from "@mui/material";

const MessageSkeleton = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: 2,
        bgcolor: "transparent",
      }}
    >
      <svg
        width="80"
        height="80"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="25"
          cy="25"
          r="20"
          stroke="#00a884"
          strokeWidth="2"
          strokeDasharray="31.4 31.4"
          strokeLinecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
        <path
          d="M15 25H35M15 20H30M15 30H25"
          stroke="#00a884"
          strokeWidth="2"
          strokeLinecap="round"
        >
          <animate
            attributeName="stroke-dasharray"
            values="0,50;50,0;0,50"
            dur="2s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
      <Typography
        sx={{
          color: "#667781",
          fontSize: 14,
          fontWeight: 500,
          letterSpacing: "0.5px",
          animation: "pulse 1.5s infinite ease-in-out",
          "@keyframes pulse": {
            "0%, 100%": { opacity: 1 },
            "50%": { opacity: 0.5 },
          },
        }}
      >
        Loading messages
      </Typography>
    </Box>
  );
};

export default MessageSkeleton;
